import '@Scss/components/_scroll-shadow.scss';
import { getElement, getElements, addClass, removeClass } from '../helpers/functions';
export default () => {
  const $wrappers = getElements('.table-responsive, .scroll-shadow');
  const updateDiv = (scrollPos, $target) => {
    const targetWidth = $target.scrollWidth - $target.clientWidth;
    if (scrollPos === 0) {
      removeClass($target, 'not-left');
    }
    if (scrollPos > 0) {
      addClass($target, 'not-left');
    }
    if (scrollPos < targetWidth) {
      addClass($target, 'not-right');
    }
    if (scrollPos === targetWidth) {
      removeClass($target, 'not-right');
    }
  };
  $wrappers.forEach($el => {
    const $wrapper = getElement('.scroll-shadow__content', $el) || $el;
    if (!$wrapper) return;
    let x = $wrapper.scrollLeft;
    updateDiv(x, $wrapper);
    $wrapper.addEventListener('scroll', () => {
      x = $wrapper.scrollLeft;
      updateDiv(x, $wrapper);
    });
    document.addEventListener('containerResize', () => {
      updateDiv(x, $wrapper);
    });
  });
};